import { Card } from "@/components/ui/card";
import { parseISO, isFuture } from "date-fns";
import { AppointmentList } from "./appointment-list";

export const PendingAppointmentsCard = ({ appointments }) => {
    const mappedAppointments = appointments.map((a) => ({
        ...a,
        date: parseISO(a.startDate),
    }));

    const sortAsc = (a, b) => a.date - b.date;

    const pendingAppointments = mappedAppointments
        .filter((a) => a.statusID === 0 && isFuture(a.date))
        .sort(sortAsc);

    return (
        <Card size="lg">
            <h2 className="mb-3 text-xl font-semibold">
                Appointments requiring your action
            </h2>
            {pendingAppointments.length == 0 ? (
                <p> You have no appointments requiring action</p>
            ) : (
                <AppointmentList appointments={pendingAppointments} />
            )}
        </Card>
    );
};
